import one from "./../assets/images/me-1.svg";
import two from "./../assets/images/me-2.svg";
import three from "./../assets/images/me-3.svg";
import four from "./../assets/images/me-4.svg";
import five from "./../assets/images/me-5.svg";
import six from "./../assets/images/me-6.svg";
import seven from "./../assets/images/me-7.svg";
import eight from "./../assets/images/me-8.svg";
import nine from "./../assets/images/me-9.svg";
import ten from "./../assets/images/me-10.svg";


// Project Images
import moon from "./../assets/images/moon.jpg";
import pro from "./../assets/images/pro.jpg";
import lol from "./../assets/images/lol.jpg";
import glide from "./../assets/images/glide.png";
import we from "./../assets/images/CNC.jpg";



const aboutData = {
  title: "Hey, I'm ",
  myName: "Ashish!",
  description: [
    "I am Electrical Engineering Sophomore at Indian Institute of Technology, Delhi.",
    "I am passionate about Front-end, Back-end and Competitive programming. I participated in many programming competitions like Google KickStart, Google CodeJam, etc.",
  ]
};

const myImages = [one, two, three, four, five, six, seven, eight, nine, ten];

const mySkills = [
  {
    skillName: "HTML-5",
    class: "devicon-html5-plain"
  },
  {
    skillName: "CSS3",
    class: "devicon-css3-plain"
  },
  {
    skillName: "JS",
    class: "devicon-javascript-plain"
  },
  {
    skillName: "REACT JS",
    class: "devicon-react-original"
  },
  {
    skillName: "C++",
    class: "devicon-cplusplus-line"
  },
  {
    skillName: "PYTHON",
    class: "devicon-python-plain"
  },
  {
    skillName: "BOOTSTRAP",
    class: "devicon-bootstrap-plain"
  },
  {
    skillName: "NODE JS",
    class: "devicon-nodejs-plain"
  },
  {
    skillName: "FIREBASE",
    class: "fa fa-fire"
  },
  {
    skillName: "JAVA",
    class: "devicon-java-plain"
  },
  {
    skillName: "TYPESCRIPT",
    class: "devicon-typescript-plain"
  },
  {
    skillName: "GITHUB",
    class: "devicon-github-plain"
  }
];

const projectsCards = [
  {
    title: "Dynamic Memory Allocator",
    subtitle: "Dynamic Memory allocation program in java withLinked List using First Split Fit algorithm",
    image: moon,
    footerLink: [
      { name: "Github", url: " " },
    ],
    language: "Java",
    langColor: "blue",
    stars: 1,
    forks: 0
  },
  {
    title: "Image Editor",
    subtitle: "Developed an Image editor for PGM (portable Gray map format) images using Python",
    image: lol,
    footerLink: [
      { name: "Github", url: "https://github.com/inductor69/Corona-Tracker" },
    ],
    language: "Python",
    langColor: "green",
    stars: 1,
    forks: 0
  },
  {
    title: "Vehicle turning indicator",
    subtitle: "Designed a physical model of vehicle turn indicator using capacitor, 555 timer IC , Diodes, Led, SPDT slide button",
    image: pro,
    footerLink: [
      { name: "Github", url: "https://github.com/inductor69/Quotes_App" },
    ],
    language: "Flutter",
    langColor: "blue",
    stars: 1,
    forks: 0
  },
  {
    title: "Wooden Glider – Aeromodelling Glider",
    subtitle: "Designedand manufactured a wooden glider and tested the balance aerodynamic features with limited materials",
    image: glide,
    footerLink: [
      { name: "Github", url: "https://github.com/inductor69/News-App" },
    ],
    language: "Flutter",
    langColor: "blue",
    stars: 1,
    forks: 0
  },
  {
    title: "CNC Machine ",
    subtitle: "Designed a keychainon an acrylic sheet by formulating a programmable code for CNC Machine ",
    image: we,
    footerLink: [
      { name: "Web App", url: "https://weatheric.netlify.app/" },
    ],
    language: "JavaScript",
    langColor: "yellow",
    stars: 1,
    forks: 0
  },

  
];

const socialMedia = {
  github: "https://github.com/ashishbhaskar11",
  linkedin: "https://www.linkedin.com/in/ashish-bhaskar-b06998188/",
  gmail: "ashishbhaskar11@gmail.com",
};

export { aboutData, myImages, mySkills, projectsCards, socialMedia };